export default {
    botao_restaurar: 'Restaurar Tarjetas Predeterminadas',
    little_cards: {
        equipamentos_total: 'Equipo Total',
        equipamentos_ativos: 'Equipo Activo',
        equipamentos_inativos: 'Equipo Inactivo',
        resultados_hora: 'Resultados / Hora'
    },
    cards: {
        minimizar: 'Minimizar Tarjeta',
        maximizar: 'Maximizar Tarjeta',
        fechar: 'Cerrar Tarjeta',
        equipment: 'Equipo',
        performance: 'Actuación (Resultados/Hora)',
        horas_atras: 'Horas Atras',
        qualityControl: 'Validación/Control de Calidad',
        triggers: 'Disparadores',
        results: 'Últimos Resultados',
        equipmentLogs: 'Errores de Equipo/Registros',
        filtrar: 'Filtrar'
    },
    widgets: {
        QualityControl: {
            codigo_exame: 'Código de Examen'
        },
        LatestResult: {
            codigo_exame: 'Código de Examen',
            columns: {
                vns_equipamento: 'VNS/Equipo',
                recipiente: 'Envase',
                paciente: 'Paciente',
                data_hora: 'Fecha/Hora',
                status: 'Estado',
                liberado: 'Liberado',
                alerta: 'Alerta',
                bloqueado: 'Obstruido',
                exame: 'Examen'
            },
            aviso_processamento: 'Al liberar el examen será procesado!',
            tem_certeza: '¿Estás seguro?',
            exame_liberado: '¡Examen liberado!',
            sucesso: 'Éxito'
        },
        TriggerWidget: {
            editar_trigger: 'Editar Disparador',
            nome: 'Nombre',
            regra: 'Regla',
            acao: 'Acción',
            editar: 'Editar'
        }
    },
    tour: {
        buttons: {
            pular_tour: 'Omitir Recorrido',
            voltar: 'Volver',
            proximo: 'Próximo',
            finalizar: 'Finalizar',
        },
        descricao: {
            equipamentos_total: '¡Muestra el número total de vns registrados!',
            equipamentos_ativos: '¡Muestra la cantidad de vns activos actualmente!',
            equipamentos_inativos: '¡Muestra la cantidad de vns actualmente inactivos!',
            resultados_hora: 'Muestra el número de exámenes realizados en el período de 1 hora',
            equipment: 'Muestra detalles operativos del equipo administrado, incluidos: nombre, estado, tiempo de actividad/inactividad',
            performance: 'Muestra el volumen de exámenes que está procesando el equipo, mostrando su evolución de uso.',
            qualityControl: 'Presenta los valores obtenidos a partir de los resultados de las pruebas de control de calidad aplicadas a los equipos gestionados.',
            triggers: 'Muestra disparadores relacionados con liberación, bloqueo, reglas de alerta, etc.',
            results: 'Presenta los resultados recibidos por fecha, hora, ID del destinatario, estado y consulta general.',
            equipmentLogs: 'Monitorear los errores/flags/estados emitidos por el equipo.'
        }
    },
    liberar_exame: {
        deseja_desbloquear: '¿Desea desbloquear?',
        desbloquear: 'Desbloquear',
        sim: 'Sí',
        nao: 'No',
        fechar: 'Cerrar'
    }    
}
